import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MotionConfig } from "framer-motion";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { consumeOAuthHash } from "./auth/token.js";
import "./i18n/index.js";
import { LoginModalProvider } from "./ui/loginModal.js";
import { TooltipProvider } from "./components/ui/tooltip.js";
import { Toaster } from "./components/ui/sonner.js";
import "./styles/index.css";

// Capture an OAuth-redirect token (#token=...) into localStorage before anything fetches.
consumeOAuthHash();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <MotionConfig reducedMotion="user">
          <TooltipProvider delayDuration={200}>
            <LoginModalProvider>
              <App />
              <Toaster />
            </LoginModalProvider>
          </TooltipProvider>
        </MotionConfig>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
